import type { Translations } from "../types";

// Canonical/reference translations - the source every other file under
// src/i18n/locales/ is translated from, and also the final fallback used by
// LanguageContext.t() if a key is ever missing from the active language
// (should never happen in practice, since Translations requires every key,
// but keeps a missing/corrupt entry from ever showing a blank string).
const en: Translations = {
  "meta.title": "Clicks by Country Map",
  "meta.description":
    "Interactive world map: free clicks per country plus paid support via Stripe, PayPal and Buy Me a Coffee.",

  "app.title": "Clicks by Country Map",

  "map.intro":
    "Click a country on the map to give it a free vote, or send it financial support - both count toward the combined leaderboard below. The map reflects only support within this app, not actual national wealth or GDP.",
  "map.verifying": "Verifying …",
  "map.confirmNotRobot": "Before you can add free clicks, quickly confirm you're not a robot:",
  "map.tryAgain": "Try again",
  "map.registeringClick": "Registering click …",
  "map.selectedCountry": "Selected country: {name}.",
  "map.selectFirstFeedback": "Country selected. To add a free click, first confirm below that you're not a robot.",
  "map.verificationExpired": "Verification expired - confirm again that you're not a robot.",
  "map.slowDown": "A bit slower - wait a moment before your next click.",
  "map.clickFailed": "Couldn't register the click. Please try again.",
  "map.clickErrorGeneric": "Error registering click.",
  "map.leaderboardHeading": "Country Leaderboard",
  "map.emptySelection": "Select a country on the map to click or support it.",
  "map.loadingData": "Loading data …",

  "worldmap.loadError": "Couldn't load the map.",
  "worldmap.resetZoom": "Reset zoom",
  "worldmap.resetButton": "⤾ Reset",
  "worldmap.loadingMap": "Loading map …",
  "worldmap.unknownCountry": "Unknown",
  "worldmap.ariaClicks": "{name}: {clicks} clicks",
  "worldmap.tooltipClicks": "{clicks} clicks",

  "legend.fewer": "Fewer clicks",
  "legend.more": "More clicks",

  "list.empty": "No clicks yet. Be the first!",
  "list.ariaLabel": "Country leaderboard by clicks",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY is not set - see README for configuration.",
  "human.verificationFailedGeneric": "Verification failed.",
  "human.networkError":
    "Couldn't reach verification (network error) - check VITE_SUPABASE_URL, that verify-human is deployed, and ALLOWED_ORIGIN; see README/NAVODILA.",
  "human.verificationFailedRetry": "Verification failed, try again.",

  "provider.stripe": "💳 Card (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Selected country",
  "panel.currentlyRanked": "Currently ranked #{rank}",
  "panel.shareCopied": "Copied ✓",
  "panel.shareShared": "Shared ✓",
  "panel.shareButton": "🔗 Share",

  "panel.tableClicks": "Clicks",
  "panel.tableFree": "Free",
  "panel.tablePaid": "Paid",
  "panel.rowAllTime": "All-time",
  "panel.rowThisYear": "This year",
  "panel.rowThisWeek": "This week",
  "panel.rowToday": "Today",

  "panel.totalCombined": "Total combined:",
  "panel.totalSupport": "Total support:",

  "panel.paymentMethod": "Payment method",
  "panel.noPaymentMethod": "No payment method is currently available.",
  "panel.supportAmount": "Support amount (EUR)",
  "panel.amountRange": "Amount should be between {min} and {max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Estimated paid clicks:",
  "panel.ratioInfo":
    "Ratio: {a} = {b} clicks (e.g. {c} = {d} clicks). This is only an estimate before payment - the final click count is always calculated and confirmed by the server based on the payment actually confirmed.",
  "panel.preparing": "Preparing …",
  "panel.continueWith": "Continue with {provider}",
  "panel.choosePaymentMethod": "Choose a payment method",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME is not set - see README for configuration.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID is not set - see README for configuration.",

  "panel.paypalAmountInfo": "Amount: {amount} (estimated {clicks} clicks). Complete payment with the PayPal button below.",
  "panel.back": "← Back",

  "panel.bmcWarningTitle": "⚠️ Before you continue to BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Paste the code below into the message/note field at checkout — that's the only way we'll know which country you're supporting. Without the code, we can't attribute the payment to any country.",
  "panel.copy": "Copy",
  "panel.copied": "Copied ✓",
  "panel.suggestedAmount": "Suggested amount:",
  "panel.bmcAmountNote":
    "(estimated {clicks} clicks). BuyMeCoffee unfortunately doesn't support carrying the amount over via link — enter/select it yourself on their site. The actual click count is always calculated from the amount you actually send on BuyMeCoffee, not from this estimate.",
  "panel.openBmc": "Open BuyMeCoffee and continue →",
  "panel.waitingProvider": "Waiting for payment confirmation from the payment provider …",
  "panel.waitingConfirmation": "Waiting for payment confirmation …",
  "panel.timedOut":
    "Checking timed out. If you completed the payment, the map will update once the server receives confirmation - this can sometimes take a little longer.",
  "panel.checkAgain": "Check again",

  "panel.cancelled": "Payment was cancelled or didn't go through. The map hasn't changed.",
  "panel.tryAgain": "Try again",

  "panel.confirmed": "✅ Support confirmed!",
  "panel.confirmedBody": "{country} received {clicks} paid clicks for {amount}.",

  "panel.errorPreparingSupport": "Error preparing your support.",
  "panel.errorPreparingPayment": "Error preparing payment.",
  "panel.errorConfirmingPayment": "Error confirming payment.",
  "panel.errorPayingPaypal": "Error paying with PayPal.",

  "share.unranked": "{flag}{country} needs your support on the world map!\nHelp it climb the leaderboard 👇",
  "share.rank1": "{flag}{country} is currently #1!\nHelp us stay on top 👇",
  "share.rankN": "{flag}{country} is currently #{rank}!\nHelp us get to #1 👇",

  "language.switcherLabel": "Language",
};

export default en;
